import qs from 'query-string';
import { apiConfig } from '../api-config';

export const getAppointmentByCdAgent = async (cdAgent: string) => {
  const userLogged = JSON.parse(sessionStorage.getItem('userLogged') as string);

  const token = userLogged.company.stKey;
  const query = qs.stringify({ cdAgent, TokenKey: token });

  return apiConfig
    .get(`/api/Appointments/get-notification-by-cdAgent?${query}`)
    .then((resp) => resp.data.objectResult || [])
    .catch((err) => ({ hasErrors: true, err }));
};
